// generated by genversion
export var version = '5.0.4';